import { useGetApiProjectsByProjectIdExtraworkgreementsQuery } from "api/generatedApi";

interface Props {
  projectId: string;
  agreementId: string;
}

export const UseGetExtraWorkAgreementById = (props: Props) => {
  const { projectId, agreementId } = props;

  const { data, error, isLoading } = useGetApiProjectsByProjectIdExtraworkgreementsQuery({ projectId: projectId ?? "" });

  const agreement = data?.extraWorkAgreements?.find((x) => x.extraWorkAgreementId === agreementId);

  return { agreement, isLoading, error };
};
